import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import { Provider } from 'react-redux'
import store from "./redux/store";

import App from './components/App';
import * as serviceWorker from './serviceWorker';

import 'semantic-ui-css/semantic.min.css'


ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));

//TODO: native like: https://medium.com/appscope/designing-native-like-progressive-web-apps-for-ios-1b3cdda1d0e8
//TODO: icons: https://developer.apple.com/design/human-interface-guidelines/ios/icons-and-images/app-icon/
const config={onUpdate:()=>{alert("onupdate");}}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister(config);
